const assignValueToRadioComps = (editor) => {

    editor.on('component:update', (component) => {

        if(component.attributes.tagName === 'label'){
            
            const parentComponent = component.parent();

            let compContent = '';

            try {
                compContent = component.view.$el[0].innerText;
              } catch (e) {
                compContent = '';
            }

            parentComponent.components().forEach( siblingComp => {
                if (siblingComp.attributes.tagName === 'input'  && siblingComp.attributes.type ==='radio' && siblingComp.attributes.attributes.value !== compContent){                    
                    if(siblingComp.attributes.attributes.value === undefined){
                        siblingComp.addAttributes({value: compContent})
                    }
                    else{
                        siblingComp.attributes.attributes.value = compContent;
                    }
                }
            })

        }

    } )

}

export default assignValueToRadioComps;
